import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  isDrawerOpen: false,
  hasInitialized: false
};

const useNotificationStore = create(
  devtools(
    (set) => ({
      ...initialState,
      setDrawerOpen: (isOpen) => {
        set({ 
          isDrawerOpen: isOpen,
          hasInitialized: true 
        }, false, 'setDrawerOpen');
      },
      toggleDrawer: () => {
        set((state) => ({ 
          isDrawerOpen: !state.isDrawerOpen,
          hasInitialized: true
        }), false, 'toggleDrawer');
      },
      resetStore: () => {
        set(initialState, false, 'resetStore');
      },
    })
  )
);

export default useNotificationStore;